<template>
  <!-- 聊天框头像组件 -->
  <div :class="['avatar-wrapper', item.value === 3 ? 'avatar-reverse' : 'avatar-unreverse']">
    <!-- 有头像 -->
    <div v-if="item?.headePortrait !== undefined && item?.headePortrait !== '' && item?.headePortrait !== null">
      <img v-if="!isError" class="avatar" :src="item.headePortrait" alt="" @error="handleImgError" />
      <!-- 图片加载错误 -->
      <div v-else class="avatar-wrapper__error avatar">
        <!-- <i class="iconfont icon-user-filled" /> -->
        <el-image :src="getDefImg(item)" fit="contain"></el-image>
      </div>
    </div>
    <!-- 没有头像 -->
    <div class="avatar-wrapper__error avatar" v-else>
      <!-- <i :class="['iconfont', item.value === 2 ? 'icon-p058jiqiren' : 'icon-user-filled']" /> -->
      <el-image :src="getDefImg(item)" fit="contain"></el-image>
    </div>
  </div>
</template>
<script setup>
import defaultBotAvatar from '@/assets/images/avatar/botavatar.png'
import defaultAvatar from '@/assets/images/avatar/avatar.png'
import defaultClientAvatar1 from '@/assets/images/avatar/clientavatar1.png'
import { defineProps, ref, watch } from 'vue'
const props = defineProps({
  item: { type: Object, default: () => {} },
  agentInfo: { type: Object, default: () => { } },
})

const getDefImg = () => {
  const item = props.item
  if (item.msgContentType === 20 && item.systemMsgType === 4) {
    return props.agentInfo?.agentHeadImg || defaultAvatar
  } else {
    if (item.value === 2) {
      if (item.source === "textbot") {
        return defaultBotAvatar
      } else {
        return defaultAvatar
      }
    } else if (item.value === 3) {
      return defaultClientAvatar1
    } else { 
      return defaultAvatar
    }
  }
}
// 图片加载错误
const isError = ref(false)
const handleImgError = () => {
  isError.value = true
}
watch(
  () => props.item,
  () => {
    isError.value = false
  },
  { immediate: true }
)
</script>
<style lang="less" scoped>
.avatar-wrapper {
  .avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    > i {
      color: #3571f0;
      font-size: 18px;
    }
  }
  &__error {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.avatar-reverse {
    margin: 3px 0 0 15px;
  }
  &.avatar-unreverse {
    margin: 3px 15px 0 0;
  }
}
</style>
